import React from 'react';

import { useCacheResource } from '../../hooks';
import { ResourceTypes } from '../../utils/services/api';
import useOpen from '../../hooks/useOpen';
import TemplateEditDrawer from './TemplateEditDrawer';
import { LabelEditLink, LabelEditLinkChildrenProps } from '../common/buttons';
const TemplateLabelWithDrawer = (props: {
  resourceId: string;
}): JSX.Element => {
  const { data, loading } = useCacheResource(
    ResourceTypes.TEMPLATE,
    props.resourceId
  );

  const oi = useOpen(false);

  if (loading) return <span />;

  return (
    <LabelEditLink
      title={data?.name || props.resourceId}
      oi={oi}
      path={'/passes/template' + props.resourceId}
    >
      {(p: LabelEditLinkChildrenProps) => {
        return (
          <TemplateEditDrawer
            id={props.resourceId}
            open={oi.open}
            onClose={p.onClose}
          />
        );
      }}
    </LabelEditLink>
  );
};

export default TemplateLabelWithDrawer;
